import { FC } from 'react';
import { AttributeValue } from '@/api/AttributeValueApi';
import { SimpleGrid } from '@mantine/core';
import { getFileSrc } from '@/utils/utilities';
import { AccordionOptionCard } from '@/components/ui/AccordionOptionCard';

interface RenderAttributeProps {
	values: AttributeValue[];
	selectedValue: AttributeValue | null;
	handleClick: (value: AttributeValue) => () => void;
}

export const RenderAttributeValues: FC<RenderAttributeProps> = ({
	values,
	selectedValue,
	handleClick,
}) => {
	return (
		<SimpleGrid
			cols={{
				base: 3,
				md: 4,
			}}
			spacing="xs"
		>
			{values.map((attributeValue) => (
				<TileAttributeValue
					key={attributeValue.id}
					attributeValue={attributeValue}
					selectedValue={selectedValue}
					handleClick={handleClick}
				/>
			))}
		</SimpleGrid>
	);
};

function TileAttributeValue({
	attributeValue,
	selectedValue,
	handleClick,
}: {
	attributeValue: AttributeValue;
	selectedValue: AttributeValue | null;
	handleClick: (value: AttributeValue) => () => void;
}) {
	const isSelected = selectedValue?.id === attributeValue.id;

	return (
		<AccordionOptionCard
			name={attributeValue.value}
			description={attributeValue.description}
			imagePath={getFileSrc(attributeValue.image?.path)}
			isSelected={isSelected}
			onSelect={handleClick(attributeValue)}
		/>
	);
}
